export const encodeColumnIndex = (input) => {
  let res = '';
  while (input > 0) {
    const next = (input - 1) % 26;
    input = (input - next - 1) / 26;

    res = `${String.fromCharCode(next + 65)}${res}`;
  }
  return res;
};
